import PropertyList from './PropertyList';

export default PropertyList;
